export default __webpack_public_path__ + "dfe0d2b7a096a3d2bd2ed49c907d24ffde8145b59a46c58f199583ff4454b1b9.svg";